import React from 'react';
import styles from './InputField.module.scss';

const InputField = ({ as = 'input', label, ...props }) => {
  const InputComponent = as;

  return (
    <div className={styles.inputContainer}>
      {label && <label className={styles.label}>{label}</label>}
      <InputComponent className={styles.inputElement} {...props} />
    </div>
  );
};

export default InputField;
